import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'urf-section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss']
})
export class SectionTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
